import { useBibliography } from '../api'
import { useLang } from '../lang'
import { Markdown } from './Markdown'
import { StateLine } from '../design'

// The Sources tab: the station's full bibliography, its own page rather than a tail on About.
// One markdown document from the profile (content/bibliography.<lang>.md). We split it at the
// first `### ` era subhead: everything before is the HEAD (the title and the fair-use note),
// set full width; everything from the first subhead on is the BODY, flowing in columns so the
// entries fill the page the way a printed bibliography does.
export function SourcesTab() {
  const { data, isLoading, isError } = useBibliography()
  const { lang } = useLang()

  if (isLoading || !data) {
    return <StateLine busy={!isError}>{isError ? '—' : '…'}</StateLine>
  }

  const md = (lang === 'ga' && data.ga?.trim() ? data.ga : data.en) ?? ''
  if (!md.trim()) return null

  const cut = md.indexOf('### ')
  const head = cut >= 0 ? md.slice(0, cut) : md
  const body = cut >= 0 ? md.slice(cut) : ''

  return (
    <section className="ed-biblio">
      <div className="ed-biblio-head">
        <Markdown source={head} />
      </div>
      {body && (
        <div className="ed-biblio-cols">
          <Markdown source={body} />
        </div>
      )}
    </section>
  )
}
